<div class="overlay"></div>
<div class="spanner">
  <div class="loader-container">
    <div class="loader"></div>
    <p class="loading-text">{{ message }}</p>
  </div>
</div>
